<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates42">
<p class="centerImage"><img alt="images" id="plate42" src="images/plate42.jpg"/></p>
<p class="caption">Showing off – our padre Don Begbie, Bill Gibbs, Tony Brook and Bob Ashby.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates42.vue?18f98a00